import { MAX_PINNED_THREADS } from '@/features/chat/pinnedThreadsConstants'

function pinnedAtMs(thread) {
  const parsed = Date.parse(String(thread?.pinnedAt ?? ''))
  return Number.isFinite(parsed) ? parsed : 0
}

export function pinnedThreadIdsFromThreads(threads = [], max = MAX_PINNED_THREADS) {
  return threads
    .filter((thread) => thread?.pinned)
    .sort((a, b) => pinnedAtMs(b) - pinnedAtMs(a))
    .slice(0, max)
    .map((thread) => thread.id)
}
